/**
 * @generated SignedSource<<2be9b5b57e38be8caa5ab715de981f7e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type usePublishReadMetadataFragment$data = {
  readonly metadata: {
    readonly sourceTemplateEntityId: string | null;
  };
  readonly " $fragmentType": "usePublishReadMetadataFragment";
};
export type usePublishReadMetadataFragment$key = {
  readonly " $data"?: usePublishReadMetadataFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePublishReadMetadataFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "usePublishReadMetadataFragment",
  "selections": [
    {
      "concreteType": "ContentMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "sourceTemplateEntityId"
        }
      ]
    }
  ],
  "type": "Content"
};

(node as any).hash = "ede47257d94a823673a218c5347d07ce";

export default node;
